import { capitalize } from 'helpers'

const transformName = (name) => {
  const splittedName = name?.split('_') || ''

  if (splittedName.length > 2) {
    const variant = splittedName.pop()
    const title = splittedName
      .reduce((acc, curr) => {
        if (curr.length === 1) return `${acc}${curr}`
        return `${acc} ${curr}`
      }, '')
      ?.trim?.()

    return variant === 'ALL'
      ? capitalize(title || '')
      : capitalize(variant || '')
  } else {
    const [domain, variant] = splittedName || []

    return variant === 'ALL'
      ? capitalize(domain || '')
      : capitalize(variant || '')
  }
}

export default transformName
